import { Copy, Trash2 } from "lucide-react";
import { format, formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { env } from "@/lib/env";
import { PARTNER_TYPE_META } from "./partner-meta";

export function PartnerInvitesList() {
  const utils = trpc.useUtils();
  const invitesQuery = trpc.partner.invite.list.useQuery({ status: "PENDING" });
  const revoke = trpc.partner.invite.revoke.useMutation({
    onSuccess: () => {
      utils.partner.invite.list.invalidate();
      toast.success("Convite revogado.");
    },
  });

  const invites = invitesQuery.data ?? [];
  if (invites.length === 0) return null;

  return (
    <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50/50 dark:border-amber-500/30 dark:bg-amber-500/5">
      <div className="flex items-center justify-between gap-2 border-b border-amber-200/60 px-3 py-2 dark:border-amber-500/20">
        <p className="text-[12px] font-semibold text-amber-900 dark:text-amber-300">
          {invites.length} convite{invites.length > 1 ? "s" : ""} pendente
          {invites.length > 1 ? "s" : ""}
        </p>
      </div>
      <ul className="divide-y divide-amber-200/40 dark:divide-amber-500/15">
        {invites.map((inv: any) => {
          const meta = PARTNER_TYPE_META[inv.type as keyof typeof PARTNER_TYPE_META];
          const url = `${env.landingUrl}/convite/${inv.token}`;
          return (
            <li
              key={inv.id}
              className="flex flex-wrap items-center gap-2 px-3 py-2 text-[12px] sm:flex-nowrap"
            >
              <span
                className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md"
                style={{
                  backgroundColor: `${meta.color}1a`,
                  color: meta.color,
                }}
              >
                <meta.icon className="h-3.5 w-3.5" />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-1.5">
                  <span className="font-semibold text-zinc-900 dark:text-foreground">
                    {meta.label}
                  </span>
                  {inv.email && (
                    <span className="truncate text-zinc-600 dark:text-muted-foreground">
                      · {inv.email}
                    </span>
                  )}
                </div>
                <p className="text-[11px] text-zinc-500 dark:text-muted-foreground">
                  Criado{" "}
                  {formatDistanceToNow(new Date(inv.createdAt), {
                    addSuffix: true,
                    locale: ptBR,
                  })}
                  {inv.expiresAt && (
                    <>
                      {" · expira "}
                      {format(new Date(inv.expiresAt), "dd/MM", { locale: ptBR })}
                    </>
                  )}
                </p>
              </div>
              <div className="flex shrink-0 items-center gap-1">
                <button
                  type="button"
                  onClick={() => {
                    navigator.clipboard.writeText(url);
                    toast.success("Link copiado.");
                  }}
                  className="flex h-7 w-7 items-center justify-center rounded-md text-zinc-600 transition-colors hover:bg-amber-100 dark:text-muted-foreground dark:hover:bg-amber-500/15"
                  title="Copiar link"
                >
                  <Copy className="h-3.5 w-3.5" />
                </button>
                <button
                  type="button"
                  onClick={() => {
                    if (confirm("Revogar esse convite?"))
                      revoke.mutate({ id: inv.id });
                  }}
                  disabled={revoke.isPending}
                  className="flex h-7 w-7 items-center justify-center rounded-md text-red-600 transition-colors hover:bg-red-100 dark:hover:bg-red-500/15 disabled:opacity-50"
                  title="Revogar"
                >
                  <Trash2 className="h-3.5 w-3.5" />
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
